import axiosInstance from '../api/axios';

export async function getComments(id: string, page: number = 1, limit: number = 10) {
  try {
    const response = await axiosInstance.get(`/comments/${id}`, {
      params: { page, limit }
    });

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function addComment(data: any) {
  try {
    const response = await axiosInstance.post(`/comments`, data);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function likeComment(id: string) {
  try {
    const response = await axiosInstance.get(`/comments/${id}/like`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}
export async function updateComment(id: string, data: any) {
  try {
    const response = await axiosInstance.put(`/comments/${id}`, data);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function deleteComment(id: string) {
  try {
    const response = await axiosInstance.delete(`/comments/${id}`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}
